var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.999,
    viewBox: "0 0 20 19.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Done",
    transform: "translate(-6.983 -14.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    d: "M559.741,203.1l-1.317,1.333a8.353,8.353,0,1,1-3.1-4.443l1.193-1.193a10,10,0,1,0,3.22,4.333Z",
    transform: "translate(-533.42 -182.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    "data-name": "Path 3891",
    d: "M558.836,210.289l-3.14-3.14-1.046,1.046,4.185,4.185,8.969-8.954-1.049-1.046Z",
    transform: "translate(-541.667 -185.341)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/Done.7b996951889c3d9d969fe8407fcc5ef2.svg";
export { ForwardRef as ReactComponent };